import React from "react";
import { Container, Typography, Box, Link } from "@mui/material";
import "./Contact.css";

const ContactUs = () => {
    return (
        <Box className="contact-page">
            <Container maxWidth="md" className="contact-container">
                <Box className="contact-box">
                    <Typography variant="h4" className="contact-title">Contact Us</Typography>
                    <Typography variant="body1" className="contact-text">
                        All Yono Master does not provide Customer Support for Listed Apps/Games.
                        If you encounter any problems, please contact the support option within those games.
                        Because the Listed Games/Apps are not ours. We do not own those games.
                    </Typography>
                    
                    <Typography variant="h5" className="contact-subtitle">Advertisement/Business Queries</Typography>
                    <Typography variant="body1" className="contact-text">
                        If you are a game maker company, operator, or administrator, and you want to promote your application
                        through our website, you can contact us through the contact details given below and discuss promotion and cooperation.
                    </Typography>
                    
                    <Typography variant="body1" className="contact-text">Email: allyonomaster@gmail.com</Typography>
                    <Typography variant="body1" className="contact-text">
                        Telegram: <Link href="https://t.me/AllYonoMaster" target="_blank" rel="noopener">https://t.me/AllYonoMaster</Link>
                    </Typography>
                    
                    <Typography variant="body1" className="contact-text">
                        You can directly contact us through Email as given above, and can deal with us.
                    </Typography>

                    <Typography variant="h6" className="contact-links">
                        <Link href="https://t.me/AllYonoMaster" target="_blank" rel="noopener">Join Our Telegram Channel</Link>
                    </Typography>
                    <Typography variant="h6" className="contact-links">
                        <Link href="#">Join Us On WhatsApp</Link>
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default ContactUs;
